import React from 'react';

interface StepperIndicatorProps {
  current: number;
  total: number;
}

export const StepperIndicator: React.FC<StepperIndicatorProps> = ({ current, total }) => {
  // Génère un tableau avec les numéros des étapes
  const steps = Array.from({ length: total }, (_, index) => index + 1);

  const getStepStatus = (stepNumber: number) => {
    if (stepNumber < current) return 'completed';
    if (stepNumber === current) return 'active';
    return 'pending';
  };

  const getStepClasses = (status: string) => {
    const baseClasses = "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-300";

    switch (status) {
      case 'completed':
        return `${baseClasses} border border-primary text-primary bg-primary/5`;
      case 'active':
        return `${baseClasses} border border-primary text-primary bg-primary/5 ring-4 ring-primary/20`;
      case 'pending':
        return `${baseClasses} bg-gray-100 text-gray-500`;
      default:
        return baseClasses;
    }
  };

  const getConnectorClasses = (stepNumber: number) => {
    const baseClasses = "flex-1 h-[1px] transition-all duration-300";
    return stepNumber < current
      ? `${baseClasses} bg-primary`
      : `${baseClasses} bg-gray-200`;
  };

  return (
    <div className='mt-8'>
      {/* StepperIndicator */}
      <div className="flex items-center justify-between">
        {steps.map((stepNumber, index) => (
          <React.Fragment key={stepNumber}>
            {/* Cercle avec numéro */}
            <div className="flex flex-col items-center">
              <div className={getStepClasses(getStepStatus(stepNumber))}>
                {getStepStatus(stepNumber) === 'completed' ? (
                  // Icône de validation pour les étapes complétées
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  stepNumber
                )}
              </div>
            </div>

            {/* Connecteur entre les étapes (sauf pour la dernière) */}
            {index < steps.length - 1 && (
              <div className={getConnectorClasses(stepNumber)} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
